import React from 'react';
import { WrapperProps } from '../../../../../../CommonComponents/OPL/Wrapper/Wrapper';
import { SplineChartLoading as BaseSplineChartLoading } from '../../../../../../CommonComponents/OPL/charts/SplineChart/SplineChart.loading';
import { EstimatedPerformanceDTO } from '../../../../api/useGetWorkflowResultsQuery';
import { theme } from '../../../../../../theme/theme';

interface Props extends WrapperProps {
  series: EstimatedPerformanceDTO['series'];
  categories: string[];
}

export const SplineChartLoading: React.FC<Props> = ({ series, categories }) => {
  const seriesWithName = series.map(({ label, data: dataPoints }) => ({
    name: label,
    data: dataPoints,
    color: theme.colors.neutral['300'],
  }));

  const chartConfig = {
    xAxis: {
      labels: {
        step: categories.length - 1,
      },
    },
    yAxis: {
      opposite: true,
    },
  };

  return (
    <BaseSplineChartLoading
      series={seriesWithName}
      categories={categories}
      customSettings={chartConfig}
    />
  );
};
